import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import OutsideClick from "./outside-click";
import GlobalKeypress from "./global-keypress";

const { any, func, bool, string } = PropTypes;

// TODO: This should use whatever overlay management we end up with
export default class Dropdown extends React.Component {
  static displayName = "Dropdown";

  static propTypes = {
    label: string,
    header: any,
    disabled: bool,
    isOpen: bool,
    closeOnUpdate: bool,
    onOpen: func,
    onClose: func,
  };

  state = { position: "left" };

  componentDidMount() {
    this.mounted = true;
    return window.addEventListener("resize", this.calcMaxHeight);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.isOpen !== this.props.isOpen) {
      return this.calcMaxHeight();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    return window.removeEventListener("resize", this.calcMaxHeight);
  }

  calcMaxHeight = () => {
    if (this.mounted && this.props.isOpen) {
      const node = this.body;
      const windowHeight = document.body.offsetHeight;
      const cords = node.getBoundingClientRect();
      const distanceFromTop = cords.top - document.body.scrollTop;
      const paddingBottom = 15;

      const content = node.querySelector(".et--dropdown--content");
      const footer_innerHeight = __guard__(node.querySelector(".et--dropdown--footer"), (x) => x.innerHeight) || 0;

      const cssMaxHeight = content ? parseInt(getComputedStyle(content)["maxHeight"], 10) : Infinity;
      const newMaxHeight = windowHeight - distanceFromTop - paddingBottom - footer_innerHeight;
      return content != null ? (content.style.maxHeight = Math.min(newMaxHeight, cssMaxHeight)) : undefined;
    }
  };

  calcPosition = () => {
    const bodyWidth = document.body.offsetWidth;
    const pos = bodyWidth + ReactDOM.findDOMNode(this).offsetLeft;
    if (pos > bodyWidth) {
      return "right";
    }
  };

  handleToggle = (evnt) => {
    if (!this.props.disabled) {
      evnt.stopPropagation();
      this.setState({ position: this.calcPosition() });

      if (!this.props.isOpen) {
        return this.open();
      }
    }
  };

  handleOutsideClick = (evnt) => {
    return this.close();
  };

  open = () => {
    return _.defer(() => {
      if (this.mounted && !this.props.isOpen) {
        return typeof this.props.onOpen === "function" ? this.props.onOpen() : undefined;
      }
    });
  };

  close = () => {
    return _.defer(() => {
      if (this.mounted && this.props.isOpen) {
        return typeof this.props.onClose === "function" ? this.props.onClose() : undefined;
      }
    });
  };

  render() {
    const bodyClasses = classNames("et--dropdown--body", {
      "is-open": this.props.isOpen,
      "is-right": this.state.position === "right",
    });

    return (
      <div className={classNames("et--dropdown", this.props.className)}>
        <div
          className={classNames("et--dropdown--header", {
            "is-disabled": this.props.disabled,
          })}
        >
          <span
            aria-label={this.props.label}
            role="button"
            tabIndex={this.props.disabled ? undefined : 0}
            onClick={this.handleToggle}
            className={classNames("et--dropdown--toggle", {
              "is-open": this.props.isOpen,
            })}
          >
            {this.props.header}
          </span>
        </div>
        <div
          className="et--advanced-combobox--content-wrapper"
          ref={(e) => {
            return (this.body = e);
          }}
        >
          {this.props.isOpen ? (
            <OutsideClick className={bodyClasses} onOutsideClick={this.handleOutsideClick}>
              {this.props.children}
            </OutsideClick>
          ) : undefined}
          {this.props.isOpen ? <GlobalKeypress onEscape={this.close} /> : undefined}
        </div>
      </div>
    );
  }
}

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}
